import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationFrames } from '../../actions/sidebar'
import { IconElement } from '../../components/FrameMenu/index'
import getFrames from '../../repositories/getFrames'

const mapStateToProps = state => ({
  isSelected: dotProp.get(state, 'sidebar.frames.isToggled', false),
})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(toggleNavigationFrames(getFrames(window.fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/SelectFrame.js